import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlobComponent } from './blob.component';
import { BlobListComponent } from './blob-list/blob-list.component';
import { BlobDetailsComponent } from './blob-details/blob-details.component';

const routes: Routes = [{
  path: '', component: BlobComponent, children: [{
path: '', 
component:BlobListComponent
  },
  { path: 'details/:id', 
  component:BlobDetailsComponent
}
  
]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlobRoutingModule { }
